import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams,LoadingController } from 'ionic-angular';
import { RestApiProvider } from '../../providers/rest-api/rest-api';
import { SceltePage } from '../scelte/scelte';

/**
 * Generated class for the EditmenusceltaPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-editmenuscelta',
  templateUrl: 'editmenuscelta.html',
})
export class EditmenusceltaPage {
  menuscelta;
  constructor(public navCtrl: NavController, public navParams: NavParams,
    private readonly loadingCtrl: LoadingController,
    public rest: RestApiProvider, 

  ) {
        this.menuscelta = navParams.get('menuscelta');

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad EditmenusceltaPage');
  }
  updateMenuScalta() {
    let loading = this.loadingCtrl.create({

      spinner: 'bubbles',
      duration: 4000,

      content: 'save Mene scelte ...'

    });

    loading.present();
    console.log('update menu scelte :' + this.menuscelta);

    console.log('update menu scelte:' + JSON.stringify(this.menuscelta));

      this.rest.aggiornaMenuScelte(this.menuscelta);


      let hideFooterTimeout1 = setTimeout(() => {
     //   loading.dismiss();
        this.navCtrl.push(SceltePage,{menuscelta:this.menuscelta}).then(() => { this.navCtrl.remove(this.navCtrl.getActive().index - 2, 2); });
  
      }, 5000);
  



  }
}



// WEBPACK FOOTER //
// ./src/pages/editmenuscelta/editmenuscelta.ts